namespace TabAurous.Production {
    export interface ReceiptMaterialForm {
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        Details: ReceiptMaterialDetailsEditor;
        EmployeeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class ReceiptMaterialForm extends Serenity.PrefixedContext {
        static formKey = 'Production.ReceiptMaterial';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReceiptMaterialForm.init)  {
                ReceiptMaterialForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = ReceiptMaterialDetailsEditor;

                Q.initFormType(ReceiptMaterialForm, [
                    'TransDate', w0,
                    'VoucherTypeId', w1,
                    'VoucherNo', w2,
                    'UserId', w3,
                    'Details', w4,
                    'EmployeeId', w1,
                    'CompanyId', w1,
                    'FinancialYearId', w1
                ]);
            }
        }
    }
}
